<template>
  <v-card class="elevation-2">
    <v-toolbar flat dense outlined>
      <v-toolbar-title class="black--text mt-4 mb-4">
        <v-icon>event</v-icon>
        Schedule
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-sheet height="128">
      <v-toolbar
          flat>
        <v-toolbar-title v-if="$refs.calendar">
          {{ $refs.calendar.title }}
        </v-toolbar-title>
        <v-btn
            fab
            text
            small
            color="grey darken-2"
            @click="prev"
        >
          <v-icon small>
            mdi-chevron-left
          </v-icon>
        </v-btn>
        <v-btn
            fab
            text
            small
            color="grey darken-2"
            @click="next"
        >
          <v-icon small>
            mdi-chevron-right
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-toolbar dense flat>
        <v-btn
            outlined
            small
            class="mr-4"
            color="grey darken-2"
            @click="setToday"
        >
          Today
        </v-btn>
        <v-spacer></v-spacer>
        <v-menu
            bottom
            right
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                small
                outlined
                color="grey darken-2"
                v-bind="attrs"
                v-on="on"
            >
              <span>{{ typeToLabel[type] }}</span>
              <v-icon right>
                mdi-menu-down
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="type = 'day'">
              <v-list-item-title>Day</v-list-item-title>
            </v-list-item>
            <v-list-item @click="type = 'week'">
              <v-list-item-title>Week</v-list-item-title>
            </v-list-item>
            <v-list-item @click="type = 'month'">
              <v-list-item-title>Month</v-list-item-title>
            </v-list-item>
            <v-list-item @click="type = '4day'">
              <v-list-item-title>4 days</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
    </v-sheet>
    <v-sheet height="600">
      <v-calendar
          ref="calendar"
          v-model="focus"
          color="grey lighten-2"
          :events="events"
          :event-color="getEventColor"
          :type="type"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="updateRange"
      >
        <template v-slot:day-body="{ date, week }">
          <div
              class="v-current-time"
              :class="{ first: date === week[0].date }"
              :style="{ top: nowY }"
          ></div>
        </template>
      </v-calendar>
      <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
      >
        <v-card
            color="grey lighten-4"
            min-width="350px"
            flat
        >
          <v-toolbar
              :color="selectedEvent.color"
              dark
          >
            <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text class="red--text" @click="deleteEvent"><v-icon>delete</v-icon>delete</v-btn>
          </v-toolbar>
          <v-card-text v-if="selectedEvent">
            <div>Start time: {{selectedEvent.start}}</div>
            <div>Estimated Finish: {{selectedEvent.end}}</div>
          </v-card-text>
          <v-card-text v-if="selectedEvent.fulfillmentData">
            <div class="headline">Active Contacts</div>
            <v-list v-if="selectedEvent.fulfillmentData">
              <v-list-item v-for="contact in selectedEvent.fulfillmentData.activeContacts" :key="contact.phoneNumber">
                <v-list-item-title>{{contact.name}}</v-list-item-title>
              </v-list-item>
            </v-list>

          </v-card-text>
          <v-card-actions>
            <v-btn
                text
                @click="selectedOpen = false"
            >
              close
            </v-btn>
            <v-btn outlined text @click="$router.push('/booking/' + selectedEvent.orderId)">Open Booking</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-sheet>
    <v-card-actions class="justify-center">
      <v-btn
          block
          text
          @click="$router.push('/bookings')"
      >
        View All Bookings
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {collection, getDocs, query, where, deleteDoc, doc} from "firebase/firestore";
import moment from "moment/moment";

export default {
  data: () => ({
    focus: '',
    type: 'week',
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      '4day': '4 Days',
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
    names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
    ready: false
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    cal () {
      return this.ready ? this.$refs.calendar : null
    },
    nowY () {
      return this.cal ? this.cal.timeToY(this.cal.times.now) + 'px' : '-10px'
    }
  },
  mounted () {
    this.$refs.calendar.checkChange()
    this.ready = true
    this.scrollToTime()
  },
  methods: {
    getCurrentTime () {
      return this.cal ? this.cal.times.now.hour * 60 + this.cal.times.now.minute : 0
    },
    scrollToTime () {
      const time = this.getCurrentTime()
      const first = Math.max(0, time - (time % 30) - 30)

      this.cal.scrollToTime(first)
    },
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
      this.scrollToTime()
    },
    getEventColor (event) {
      return event.color
    },
    setToday () {
      this.focus = ''
      this.scrollToTime()
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
      }
      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }
      nativeEvent.stopPropagation()
    },
    updateRange ({ start, end }) {
      // console.log(start)
      let qStart = new Date (start.date)
      let qEnd = new Date (end.date)
      let epochStart = qStart.getTime()
      let epochEnd = qEnd.getTime()
      // console.log(qEnd.getTime())
      let db = this.$store.state.db
      let scheduleRef =  collection(db, 'users', this.user.uid, 'schedule')
      let scheduleQuery = query(scheduleRef, where('formattedStartDate', '>=', epochStart), where('formattedStartDate', '<=', epochEnd))
      return getDocs(scheduleQuery)
          .then (res => {
            // console.log(res)
            let events = []
            if(!res.empty) {
              res.forEach(doc => {
                events.push(doc.data())
              })
              this.events = events
              // console.log(events)
            }
          })
    },
    deleteEvent () {
      // console.log(this.selectedEvent)
      let db = this.$store.state.db
      let eventRef =  doc(db, 'users', this.user.uid, 'schedule', this.selectedEvent.orderId)
      return deleteDoc(eventRef)
          .then(() => {
            this.selectedOpen = false
            let index = this.events.indexOf(this.selectedEvent)
            return this.events.splice(index, 1)
          })
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>
<style lang="scss" scoped>
.v-current-time {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;

  &.first::before {
    content: '';
    position: absolute;
    background-color: #ea4335;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  }
}
</style>

